import styles from './CMSCard.module.scss';

function CMSCard({ children }) {
  return <div className={styles.card}>{children}</div>;
}

export default CMSCard;
